module.exports = __webpack_public_path__ + "static/media/LICENSE.3b83ef96.txt";